module.exports = __webpack_public_path__ + "static/Future-of-Work-Template-Articles-1280-x-720-12-800x450-8c197c9057911afc5bc90f278f634bfa.png";